










































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ICartItem } from '@/store/models/CartItem'
import '@/icons/delete'
import { Offer, BasketType } from '@/data/enums'
@Component
export default class ShoppingCartItem extends Vue {
  @Prop() public item!: ICartItem
  private detailsOpen: boolean = false
  private optionsOpen: boolean = false

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get hasDiscount (): boolean {
    if (this.item) {
      if (this.item.discountPrice && this.item.discountPrice > 0) {
        return true
      }
    }
    return false
  }

  private get displayButton (): string {
    if (this.$store.state.data.optician.frameSelectionButton) {
      return this.$store.state.data.optician.frameSelectionButton
    }
    return ''
  }

  private get isOfferItem (): boolean {
    if (this.item) {
      if (this.item.glasses.id === Offer.Screen || this.item.glasses.id === Offer.Sun) {
        return false // temp disable!
      }
      return false
    }
    return false
  }
}
